// extracted by mini-css-extract-plugin
export default {"floatingActionButtons":"FloatingActionButtons_floatingActionButtons__PP-Ab"};